var React = require('react');

function Caret (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 40.0001L2.99999 21.0001L22 2.00002","stroke":"currentColor","strokeWidth":"4"}));
}

Caret.defaultProps = {"width":"41","height":"42","viewBox":"0 0 41 42","fill":"none"};

module.exports = Caret;

Caret.default = Caret;
